import { ReactNode } from "react";

export enum RoutingStrategy {
  browser,
  memory,
}

export type Routes = {
  path: string;
  element: ReactNode;
}[];
